import {httpGet, httpPost, httpPut} from "./http";

const locationsUrl = window.env.BACKEND_API_URL + "/locations";

//region REST
const addLocation = async ({name, description, latitude, longitude, publicNote, privateNote}, signal) => {
    const body = {
        name,
        description,
    };

    //make sure 0 can be preserved for lat and long
    if (latitude !== undefined && latitude !== null) body['latitude'] = latitude;
    if (longitude !== undefined && longitude !== null) body['longitude'] = longitude;

    if (publicNote) body['public_note'] = publicNote;
    if (privateNote) body['private_note'] = privateNote;

    return httpPost(locationsUrl, body, signal);
};

const getAllLocations = async (page, pageSize, sort = 'name', signal) => {
    let allUrl = `${locationsUrl}?page=${page}&per_page=${pageSize}&sort=${sort}`;

    return httpGet(allUrl, signal);
};

const getSingleLocation = async (locationID, signal) => {
    let singleLocationUrl = `${locationsUrl}/${locationID}`;

    return httpGet(singleLocationUrl, signal);
};

const updateLocation = async (locationID, {name, description, latitude, longitude, public_note, private_note}, signal) => {
    const locationUpdateUrl = `${locationsUrl}/${locationID}`;

    const body = {
        name,
        description,
        latitude,
        longitude,
        public_note,
        private_note,
    };

    return await httpPut(locationUpdateUrl, body, signal);
};

//endregion

const buildLocationDescription = (locationName, locationDescription = null) => {
    let result;

    if (locationDescription) {
        result = locationName + ' - ' + locationDescription;
    } else {
        result = locationName;
    }

    return result;
};

export {
    addLocation,
    getAllLocations,
    getSingleLocation,
    updateLocation,
    buildLocationDescription,
};
